var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileInvoiceEuroLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#ea6927;stroke-width:10.2341;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,80c0-8.8,7.2-16,16-16h64c8.8,0,16,7.2,16,16s-7.2,16-16,16H80C71.2,96,64,88.8,64,80z",
    fill: "#ea6927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,144c0-8.8,7.2-16,16-16h64c8.8,0,16,7.2,16,16s-7.2,16-16,16H80C71.2,160,64,152.8,64,144z",
    fill: "#ea6927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,129.9L254,14.1C245,5.1,232.8,0,220.1,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h256c35.3,0,64-28.7,64-64   V163.8C384,151.1,378.9,138.9,369.9,129.9z M224,32.5c2.8,0.7,5.3,2.1,7.4,4.2l115.9,115.9c2.1,2,3.5,4.6,4.2,7.4H240   c-8.8,0-16-7.2-16-16V32.5z M352,448c0,17.7-14.3,32-32,32H64c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32h128v112   c0,26.5,21.5,48,48,48h112V448z",
    fill: "#ea6927"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.5,427.4c-13.6,0-26-2.8-37.3-8.6c-11.2-5.7-20.8-13.4-28.6-23.1c-7.8-9.7-13.5-20.7-17.1-32.9h-16.6    c-2.6,0-4.7-0.9-6.5-2.7c-1.8-1.8-2.7-4-2.7-6.5s0.9-4.8,2.7-6.6c1.8-1.9,4-2.8,6.5-2.8h13.3c-0.2-1.4-0.3-2.8-0.3-4.2    c0-1.4,0-2.8,0-4.2c0-1.7,0-3.4,0.1-5.2c0.1-1.8,0.2-3.5,0.4-5.2h-13.5c-2.6,0-4.7-0.9-6.5-2.7c-1.8-1.8-2.7-4-2.7-6.5    s0.9-4.7,2.7-6.5c1.8-1.8,4-2.7,6.5-2.7h17.6c3.4-10.7,8.6-20.9,15.6-30.4c7-9.5,16-17.3,27.1-23.4c11.1-6,24.2-9.1,39.3-9.1    c13.6,0,26,2.7,37.3,8.2c3.9,1.9,5.9,4.9,5.9,9.2c0,2.7-1,5.1-3.1,7.2c-2,2-4.5,3.1-7.4,3.1c-0.7,0-1.5-0.2-2.4-0.5    c-0.9-0.3-1.7-0.6-2.4-0.8c-3.7-1.4-7.9-2.4-12.4-3.2c-4.5-0.8-9.7-1.1-15.5-1.1c-13.6,0-25.5,3.9-35.5,11.6    c-10,7.7-17.5,17.5-22.2,29.2h73.8c2.6,0,4.7,0.9,6.5,2.7c1.8,1.8,2.7,4,2.7,6.5c0,2.4-0.9,4.5-2.7,6.4c-1.8,1.9-4,2.8-6.5,2.8    H155c-0.5,3.2-0.8,6.7-0.8,10.5c0,1.4,0,2.8,0.1,4.2c0.1,1.4,0.2,2.9,0.4,4.2h66.1c2.6,0,4.8,0.9,6.6,2.8c1.9,1.9,2.8,4.1,2.8,6.6    c0,2.7-0.9,4.9-2.6,6.6c-1.7,1.7-4,2.6-6.9,2.6h-62.1c4.8,12.6,12.4,22.9,22.9,30.8c10.5,7.9,22.4,11.9,35.9,11.9    c5.8,0,10.9-0.4,15.5-1.1c4.5-0.8,8.6-1.8,12.4-3.2c0.7-0.3,1.5-0.6,2.4-0.9c0.9-0.3,1.7-0.4,2.4-0.4c2.9,0,5.4,1,7.4,2.9    c2,2,3.1,4.4,3.1,7.3c0,4.1-2,7.1-5.9,9.2C243.6,424.7,231.2,427.4,217.5,427.4z",
    fill: "#ea6927"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceEuroLight);
export default __webpack_public_path__ + "static/media/file-invoice-euro-light.84126caaaa1bb76d89aaada682fb1b19.svg";
export { ForwardRef as ReactComponent };